import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Breadcrumb from 'components/Common/Breadcrumb';

import OverviewCard from './OverviewCard';
import MedicineInfo from './MedicineInfoCard';
import DosageInstructions from './DosageInstructionsCard';
import RegulatoryInfo from './RegulatoryInfoCard';
import MiniCards from './MiniStatsCards';
import ActiveIngredients from './ActiveIngredientsTable';
import SideEffects from './SideEffectsTable';
import PurchaseHistory from './PurchaseHistoryTable';
import Inventory from './InventoryTable';
import ClinicalStudies from './ClinicalStudiesCard';
import Contraindications from './ContraindicationsCard';
import Pricing from './PricingCard';
import { useParams } from 'react-router-dom';

const MedicineDetail = () => {
  const { medicineId } = useParams();

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="Medicines" breadcrumbItem="Paracetamol" />
        <Row>
          <Col xl="4">
            <OverviewCard medicineId={medicineId} />
            <MedicineInfo />
            <DosageInstructions />
            <RegulatoryInfo />
          </Col>
          <Col xl="8">
            <MiniCards />
            <ActiveIngredients />
            <SideEffects />
            <PurchaseHistory />
            <Inventory />
            <ClinicalStudies />
            <Contraindications />
            <Pricing />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MedicineDetail;
